import Template from "../../../components/template";
import CardWithHeaderTemplate from "../../../components/cardWithHeaderTemplate";
import HeaderView from "./components/HeaderView";
import BodyView from "./components/BodyView";

const Html = () => {
    return (
        <Template>
            <div className="container-fluid py-2">
                <div className="row">
                    <div className="col-12">
                        <CardWithHeaderTemplate
                            header={<HeaderView/>}
                            body={<BodyView/>} 
                        />
                    </div>
                </div>

            </div>
        </Template>
    );
};

export default Html;